import { useCallback } from 'react';
import { useNotificationMessages } from 'hooks/useNotificationMessages';
import { useSupplierOfferPublishMutation } from 'api';
import { Form } from 'components';
import { AddBrandModal } from './index';

export const useAddBrandModal = (props: Omit<AddBrandModal, 'openModal'>) => {
  const { onCancelModal, recordId } = props;
  const [form] = Form.useForm();
  const { handleError, handleSuccess } = useNotificationMessages();

  const [supplierOfferPublish, { isLoading }] = useSupplierOfferPublishMutation();

  const onCancel = useCallback(() => {
    form.resetFields();
    onCancelModal();
  }, [form, onCancelModal]);

  const onFinish = useCallback(async () => {
    // const brandId = form.getFieldValue('brandId');
    if (recordId) {
      try {
        const { data, error } = await supplierOfferPublish(recordId);
        if (data?.success) {
          handleSuccess('Brand was successfully published add to supplier offer.');
          onCancel();
        } else {
          handleError(error);
        }
      } catch (err) {
        handleError(err);
      }
    }
  }, [handleSuccess, onCancel, handleError, supplierOfferPublish, recordId]);

  return {
    onFinish,
    isLoading,
    form,
    onCancel,
  };
};
